import Swal from "sweetalert2";

const {default: store} = require("../store");
// const {default: router} = require("../router");
const axios = require("axios")
export default {
    every: [
      {
        action:()=>{
          // console.log('BEFORE-EVERY',store)
          store.commit('loadModSelector', false)
        }
      }
    ],
    restrictions:{
        loginPaths:'',
        roles:[
            // {
            //     role: 'ind',
            //     redirect: '/'
            // },
            // {
            //     role: 'org',
            //     redirect: '/'
            // },
            {
                role: 'admin',
                redirect: '/adminlogin'
            }
        ],
        // beforeLogin:[
        //     {
        //         action:()=>{
        //           // console.log('BEFORE-LOGIN',store)
        //           store.commit('loadModSelector', false)
        //         }
        //     }
        // ],
        postLogin:[
            {
                action:async ()=>{
                  // let user = store.state.login.user
                  //   if(user.role.find(r=>r.name=='ind')){
                  //       let profile = await axios.get(`/api/data/UserProfile/my/all/all/default.live`)
                  //       if(profile.data.length > 0){
                  //         user.profile = profile.data[0]
                  //         console.log('USER PROFILE LOADED',user)
                  //         store.commit('login',user)
                  //       }
                  //   }
                  //   else if(user.role.find(r=>r.name=='org')){
                  //       let orginfo = await axios.get(`/api/data/Company/my/all/all/default.live`)
                  //       if(orginfo.data.length >0){
                  //           user.orginfo = orginfo.data[0]
                  //           console.log('COMPANY INFO LOADED')
                  //           store.commit('login',user)
                  //       }
                  //   }            


                    let user = store.state.login.user
                    // if(user.role.find(r=>r.name=='ind')){
                        let profile = await axios.get(`/api/data/UserProfile/my/all/all/default.live`)
                        if(profile.data.length > 0){
                          user.profile = profile.data[0]
                          console.log('USER PROFILE LOADED',user)
                          store.commit('login',user)
                        }
                        // else{
                        //   router.push('/user/info/edit')
                        // }
                    // }
                    // else if(user.role.find(r=>r.name=='org')){
                        let orginfo = await axios.get(`/api/data/Company/my/all/all/default.live`)
                        if(orginfo.data.length >0){
                            user.orginfo = orginfo.data[0]
                            console.log('COMPANY INFO LOADED')
                            store.commit('login',user)
                        }
                    // }

                  }
            }
        ],
        userBasedChecks:[
            {
                name: 'realname',
                // role: 'ind',
                yes:async ()=>{
                    //检查是否已做实名
                    let realname = await axios.get('/api/data/UserRealname/my/all/approve=true/default.live')
                    // console.log('实名',realname)
                    return realname.data.length != 0
                },
                redirect: '/user/info/realname'
            },
            {
              name: 'profile',
              // role: 'ind',
              yes: async()=>{
                //检查是否已经填写用户信息
                let profile = await axios.get('/api/data/UserProfile/my/all/all/default.size')
                console.log('Checking Profile', profile)
                return profile.data.size != 0
              },
              redirect : '/user/info/edit'
            },
            {
              name: 'orgprofile',
              // role: 'ind',
              yes: async()=>{
                let profile = await axios.get('/api/data/Company/my/all/all/default.size')
                console.log('Checking Org', profile)
                return profile.data.size != 0
              },
              redirect: '/user/org/info/edit'
            },
            {
              name: 'orgvip',
              yes: async()=>{
                console.log('ORGVIP-USER',store.state.login.user);
                if(store.state.login.user){
                  console.log('ORGVIP-ORGINFO',store.state.login.user.orginfo);
                  return true;
                }
                else{
                  await Swal.fire({title: '登录'});
                  console.log('NOT VIP')
                  return false;
                }
              },
            }
        ],
    },
    routes:[
      {
        path: '/ad/:id',
        component: ()=> import('../3dmojing/ad.vue')
      },
        {
          path: '/moreadmin',
          meta: {roles:['admin']},
          component: ()=>import('../../../yet2-vue/src/yet/v/admin_layout.vue'),
          children: [
            {
              path: 'role',
              component: ()=>import('../3dmojing/admin/role.vue')
            }
          ]
        },
        {
          path: '/about',
          component: ()=>import('../3dmojing/static/layout.vue'),
          children:[
            {
              path: '',
              component: ()=>import('../3dmojing/static/about.vue')
            }
          ]
        },
        {
          path: '/faq',
          component: ()=>import('../3dmojing/static/layout.vue'),
          children:[
            {
              path: '',
              component: ()=>import('../3dmojing/static/faq.vue')
            }
          ]
        },
        {
          path: '/term',
          component: ()=>import('../3dmojing/static/layout.vue'),
          children:[
            {
              path: '',
              component: ()=>import('../3dmojing/static/term.vue')
            }
          ]
        },
        {
          path: '/',
          component: ()=>import('../3dmojing/layouts/default.vue'),
          children: [
            {
              path: '',
//               redirect: '/ai/list'
                 redirect: '/mjindex'
//               component: ()=>import('../3dmojing/landing.vue')
            },
            {
              path: 'about-landing',
              component: ()=>import('../3dmojing/landing.vue')
            },
            {
              path: 'mjindex',
              component: ()=>import('../3dmojing/index.vue')
            },
            {
              path: 'mods',
              component: ()=>import('../3dmojing/mods/layout.vue'),
              // meta: {test:true},
              children: [
                {
                  path: '',
                  name: 'ModList',
                  component: ()=>import('../3dmojing/mods/list.vue'),
                },
                // {
                //   path: 'collection/digest',
                //   name: 'digestmod',
                //   component: ()=>import('../3dmojing/collection/index.vue')
                // },
                {
                  path: 'sort/:sort/:rand?',
                  component: ()=>import('../3dmojing/mods/list.vue')
                },
                {
                  path: 'search',
                  component: ()=>import('../3dmojing/mods/search.vue')
                },
                {
                  meta: { login:true},
                  path: 'buy/:id',
                  component: ()=>import('../3dmojing/mods/buy.vue')
                },                
                {
                  path: ':id',
                  component: ()=>import('../3dmojing/mods/detail.vue')
                },
              ]
            },
            {
              path: 'user',
              component: () => import('../3dmojing/user/layout.vue'),
              // meta: {roles:['ind'], login:true, skip_bg: false},
              meta: {login:true, skip_bg: false,
                // roles:['ind']
              },
              children:[
                {
                  path: 'info',
                  props:{ sub_menu: {title: "我的信息", menu:[
                    { title: '个人资料', link: '/user/info/show'},
                    { title: '实名验证', link: '/user/info/realname'},
                    { title: '我的简历', link: '/user/info/resume'},
                  ]} },
                  components: {
                    default: ()=>import('../3dmojing/user/layout_bridge.vue'),
                    sub_menu: ()=>import('../3dmojing/user/menu.vue'),
                  },
                  children: [
                    {
                      path: '',
                      redirect: '/user/info/show'
                    },
                    {
                      path: 'show',
                      meta: {checks: ['profile']},
                      component: () => import('../3dmojing/user/info/index.vue')
                    },
                    {
                      path: 'edit',
                      component: () => import('../3dmojing/user/info/edit.vue'),
                    },
                    {
                      path: 'realname',
                      meta: {checks: ['profile']},
                      component: ()=> import('../3dmojing/user/info/realname.vue')
                    },
                    {
                      path: 'resume',
                      meta: {checks:['realname','profile'], skip_bg: true},
                      component: ()=>import('../3dmojing/user/layout_bridge'),
                      children:[
                        {
                          path: '',
                          redirect: 'show'
                        },
                        {
                          path: 'show',
                          components:{
                            default: ()=> import('../3dmojing/designer/designer.vue'),
                            sub_menu: ()=>import('../3dmojing/user/menu.vue')
                          }
                        },
                        {
                          path: 'edit',
                          // meta: {checks:['realname','profile']},
                          components:{
                            default: ()=> import('../3dmojing/user/resume/index.vue'),
                            sub_menu: ()=>import('../3dmojing/user/menu.vue')
                          } 
                        },
                      ]

                    },
                   
                  ]
                },
                {
                  path: 'fav',
                  props:{ sub_menu: {title: "我的收藏", menu:[
                    { title:'模型收藏', link: '/user/fav/mod'},
                    { title:'图片集收藏', link: '/user/fav/collection'},
                    { title:'AI图片收藏', link: '/user/fav/ai'},
                    // { title:'关注课程', link: '/user/fav/course'},
                    { title:'关注作者', link: '/user/fav/designer'}
                  ]} },
                  components: {
                    default: ()=>import('../3dmojing/user/layout_bridge.vue'),
                    sub_menu: ()=>import('../3dmojing/user/menu.vue'),
                  },
                  children: [
                    {
                      path: '',
                      redirect: 'mod'
                    },
                    {
                      path: 'mod',
                      component: () => import('../3dmojing/user/fav/mod.vue')
                    },
                    {
                      path: 'ai',
                      component: () => import('../3dmojing/user/fav/ai.vue')
                    },
                    {
                      path: 'collection',
                      component: () => import('../3dmojing/user/fav/collection.vue'),
                    },
                    {
                      path: 'course',
                      component: ()=> import('../3dmojing/user/fav/course.vue')
                    },
                    {
                      path: 'designer',
                      component: ()=> import('../3dmojing/user/fav/designer.vue')
                    }
                  ]
                },
                {
                  path: 'upload',
                  meta: {checks:['realname','profile']},
                  props:{ sub_menu: {title: "我的上传", menu:[
                    { title:'所有模型', link: '/user/upload/list'},
                    { title:'上传', link: '/user/upload/new'},
                  ]} },
                  components: {
                    default: ()=> import('../3dmojing/user/layout_bridge.vue'),
                    sub_menu: ()=>import('../3dmojing/user/menu.vue'),
                  },
                  children: [
                    {
                      path: '',
                      redirect: 'list'
                    },
                    {
                      path: 'list',
                      component: ()=>import('../3dmojing/user/upload/aduit.vue')
                    },
                    {
                      path: 'new',
                      component: ()=>import('../3dmojing/user/upload/upload.vue')
                    },
                    {
                      path: 'edit/:dataid',
                      component: ()=>import('../3dmojing/user/upload/upload.vue')
                    }
                  ]
                },
                {
                  path: 'withdraw',
                  props: {sub_menu: {title: "资金管理", menu:[
                    {
                      title: '收入记录',
                      link: '/user/withdraw/pay'
                    },
                    {
                      title: '购买记录',
                      link: '/user/withdraw/buy'
                    },
                    {
                      title: '提现记录',
                      link: '/user/withdraw/withdraw'
                    },
                    {
                      title: '提现申请',
                      link: '/user/withdraw/bank/cashing'
                    }
                  ]}},
                  components: {
                    default: ()=> import('../3dmojing/user/layout_bridge'),
                    sub_menu: ()=>import('../3dmojing/user/menu.vue')
                  },
                  children: [
                    {
                      path: 'bank/cashing',
                      props: {sub_menu: {title: '提现申请'}},
                      component: ()=> import('../3dmojing/user/withdraw/withdraw.vue'),
                    },
                    {
                      path: ':list?',
                      
                      component: ()=> import('../3dmojing/user/withdraw/pay.vue'),
                    },
                  ]
                },
                {
                  path: 'msg',
                  meta: {skip_bg:true},
                  props:{ sub_menu: {title: "消息公告", menu:[
                    { title:'消息公告', link: '/user/msg'},
                  ]} },
                  components: {
                    default: ()=> import('../3dmojing/user/layout_bridge.vue'),
                    sub_menu: ()=>import('../3dmojing/user/menu.vue'),
                  },
                  children: [
                    {
                      path: '',
                      component: ()=>import('../3dmojing/user/msg/index.vue')
                    },
                    {
                      path: 'show/:id',
                      component: ()=>import('../3dmojing/user/msg/announcement.vue')
                    }
                  ]
                },
                {
                  path: 'collection',
                  props:{ sub_menu: {title: "我的图片集", menu:[
                    { title:'发布图片集', link: '/user/collection/form/new'},
                    { title:'我的图片集', link: '/user/collection/list'},
                  ]} },
                  components: {
                    default: ()=> import('../3dmojing/user/layout_bridge.vue'),
                    sub_menu: ()=>import('../3dmojing/user/menu.vue'),
                  },
                  children: [
                    {
                      path: '',
                      redirect: 'list'
                    },
                    {
                      path: 'list',
                      component: ()=>import('../3dmojing/user/collection/list.vue')
                    },
                    {
                      path: 'form/new',
                      component: ()=>import('../3dmojing/user/collection/form.vue')
                    }
                  ]
                },
                {
                  path: 'ai',
                  meta: {section: 'ai'},
                  props: {sub_menu: {title: "AI图片", menu:[
                    {title: '上传系列AI图片',link: '/user/ai/batch'},
                    {title: '上传AI图片', link: '/user/ai/upload'},
                    {title: '我的AI图片', link: '/user/ai/list'},
                  ]}},
                  components: {
                    default: ()=>import('../3dmojing/user/layout_bridge.vue'),
                    sub_menu: ()=>import('../3dmojing/user/menu.vue'),
                  },
                  children : [
                    {
                      path: '',
                      redirect: '/user/ai/list'
                    },
                    {
                      path: 'list',
                      component: ()=>import('../3dmojing/user/ai/index.vue')
                    },
                    {
                      path: 'upload/:dataid?',
                      component: ()=>import('../3dmojing/user/ai/upload.vue')
                    },
                    {
                      path: 'detail/:id',
                      component: ()=>import('../3dmojing/user/ai/detail.vue')
                    },
                    {
                      path: 'batch',
                      component: ()=>import('../3dmojing/user/ai/batch.vue')
                    }
                  ]
                },
                {
                  path: 'org',
                  meta: {section: 'org'},
                  props:{ sub_menu: {title: "企业功能", menu:[
                    { title: '企业信息', link: '/user/org/info'},
                    { title: '招聘岗位', link: '/user/org/job'},
                    { title: '应聘简历', link: '/user/org/resume'},
                    { title: '入驻包商', link: '/user/org/provider'},
                  ]} },
                  components: {
                    default: ()=>import('../3dmojing/user/layout_bridge.vue'),
                    sub_menu: ()=>import('../3dmojing/user/menu.vue'),
                  },
                  children:[
                    {
                      path: '',
                      meta: {checks: ['orgprofile']},
                      redirect: 'info'
                    },
                    {
                      path: 'info',
                      meta: {checks: ['orgprofile']},
                      component: ()=>import('../3dmojing/org/info/index.vue')
                    },
                    {
                      path: 'provider/:edit?',
                      meta: {checks: ['orgprofile']},
                      component: ()=>import('../3dmojing/org/provider.vue')
                    },
                    {
                      path: 'info/edit',
                      component: ()=>import('../3dmojing/org/info/edit.vue')
                    },
                    {
                      path: 'job',
                      meta: {checks: ['orgprofile']},
                      component: ()=>import('../3dmojing/org/job/list.vue')
                    },
                    {
                      path: 'job/edit',
                      meta: {checks: ['orgprofile']},
                      component: ()=>import('../3dmojing/org/job/edit.vue')
                    },
                    {
                      path: 'resume',
                      meta: {checks: ['orgprofile']},
                      component: ()=>import('../3dmojing/org/resume/index.vue')
                    }                    
                  ]
                }
              ]
            },
            {
              name: 'editCollection',
              path: 'user/collection/image/:id',
              component: ()=>import('../3dmojing/user/collection/upload_item.vue'),     
            },
            {
              path: 'org',
              component: () => import('../3dmojing/user/layout.vue'),
              // meta: {roles: ['org'],login:true},
              meta: {login:true},
              children:[
                {
                  path: '',
                  components: {
                    default: ()=>import('../3dmojing/user/layout_bridge.vue'),
                    sub_menu: ()=>import('../3dmojing/user/menu.vue'),
                  },
                  children:[
                    {
                      path: 'info',
                      component: ()=>import('../3dmojing/org/info/index.vue')
                    },
                    {
                      path: 'provider/:edit?',
                      component: ()=>import('../3dmojing/org/provider.vue')
                    },
                    {
                      path: 'info/edit',
                      component: ()=>import('../3dmojing/org/info/edit.vue')
                    },
                    {
                      path: 'job',
                      component: ()=>import('../3dmojing/org/job/list.vue')
                    },
                    {
                      path: 'job/edit',
                      component: ()=>import('../3dmojing/org/job/edit.vue')
                    },
                    {
                      path: 'resume',
                      component: ()=>import('../3dmojing/org/resume/index.vue')
                    }                    
                  ]
                }
              ]
            },
            {
              path: 'org/vip',
              component: () => import('../3dmojing/designer/layout.vue'),
              children: [
                {
                  path: '',
                  component: ()=>import('../3dmojing/org/vip/products.vue')
                },
                {
                  path: 'buy/:id',
                  component: ()=>import('../3dmojing/org/vip/buy.vue')
                }
              ]
            },
            {
              path: 'designer',
              component: () => import('../3dmojing/designer/layout.vue'),
              children: [
                {
                  path: '',
                  component: ()=>import('../3dmojing/designer/index.vue'),
                },
                {
                  path: 'jobs',
                  component: ()=>import('../3dmojing/designer/jobs_list.vue')
                },
                {
                  path: 'company/:id',
                  component: ()=>import('../3dmojing/designer/company.vue')
                },
                {
                  path: 'company/job/:id',
                  component: ()=>import('../3dmojing/designer/job.vue')
                },
                {
                  path: 'search',
                  component: ()=>import('../3dmojing/designer/designer_search')
                },
                {
                  path: 'detail/:id',
                  meta: {checks: ['orgvip'],login:true},
                  component: ()=>import('../3dmojing/designer/designer.vue')
                },
                {
                  path: 'works/:id',
                  component: ()=>import('../3dmojing/designer/works.vue')
                }
              ]
            },
            {
              path: 'online',
              component: () => import('../3dmojing/online/index.vue'),
            },
            {
              path: 'offline',
              component: () => import('../3dmojing/offline/index.vue'),
            },
            {
              path: 'vender',
              component: ()=> import('../3dmojing/vender/layout.vue'),
              children:[
                {
                  path: '',
                  meta: {login: true},
                  component: () => import('../3dmojing/vender/index.vue')
                },
                {
                  path: 'detail/:id',
                  meta: {login: true},
                  component: () => import('../3dmojing/vender/detail.vue')
                }
              ]
            },
            {
              path: 'collection',
              component: ()=> import('../3dmojing/collection/layout.vue'),
              children: [
                {
                  path: ':category?/show/:id',
                  props: true,
                  component: ()=>import('../3dmojing/collection/detail.vue')
                },
                {
                  path: ':category?/tip/:id',
                  props: true,
                  component: ()=>import('../3dmojing/collection/tip.vue')
                },
                {
                  path: ':category?/:imagetype?/:sort?',
                  props: true,
                  component: ()=>import('../3dmojing/collection/index.vue')
                }
              ]
            },
            {
                path: 'ai',
                name: 'ai',
                component: ()=> import('../3dmojing/collection/layout.vue'),
                children: [
                  {
                    path: 'list/:category?/:sort?',
                    name: 'ai',
                    props: true,
                    component: ()=>import('../3dmojing/ai/index.vue')
                  },
                  {
                    path: 'detail/:id?',
                    name: 'ai',
                    component: ()=>import('../3dmojing/ai/detail.vue'),
                    props: true
                  }
                ]
            }
          ]
        },
      ]
}